'use client';
import { Modal } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { FaApple } from 'react-icons/fa';

const APP_STORE_URL = 'https://apps.apple.com/cz/app/tipbuddy/id6763794416';
const STORAGE_KEY = 'tipbuddy-ios-app-promo-seen';

export default function IosAppPromoModal() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    try {
      setShowModal(localStorage.getItem(STORAGE_KEY) !== 'true');
    } catch {
      setShowModal(true);
    }
  }, []);

  const rememberAndClose = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Local storage can be unavailable in private browsing modes.
    }
    setShowModal(false);
  };

  return (
    <Modal show={showModal} onClose={rememberAndClose}>
      <Modal.Header className={'dark:bg-black'}>TipBuddy pro iOS</Modal.Header>
      <Modal.Body className={'dark:bg-black'}>
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-black text-white dark:bg-white dark:text-black">
            <FaApple className="h-8 w-8" />
          </div>
          <div className="space-y-2">
            <p className="text-lg font-bold text-gray-900 dark:text-white">Máme novou aplikaci pro iPhone.</p>
            <p className="text-sm text-gray-700 dark:text-gray-200">
              Tipuj zápasy pohodlněji přímo v aplikaci TipBuddy pro iOS.
            </p>
          </div>
          <div>
            <p className={"text-sm font-bold text-gray-700 dark:text-gray-200"}>Co v aplikaci najdete?</p>
            <ul className={"list-disc list-inside text-left text-sm text-gray-700 dark:text-gray-200"}>
              <li>Rychlejší načítání a plynulejší ovládání</li>
              <li>Modernější vzhled a přizpůsobení pro iOS</li>
              <li>Přehlednější vyplňování tipů</li>
              <li>Upozornění na nevyplněné tipy</li>
              <li>Upozornění na uzavření zápasu</li>
              <li>Zaplacení registračního poplatku pomocí Apple Pay</li>
            </ul>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex flex-row flex-wrap items-center place-content-center gap-2 dark:bg-black">
        <button type="button" className="default-button" onClick={rememberAndClose}>
          Zavřít
        </button>
        <a
          className="default-button"
          href={APP_STORE_URL}
          target="_blank"
          rel="noreferrer"
          onClick={rememberAndClose}
        >
          <FaApple /> App Store
        </a>
      </Modal.Footer>
    </Modal>
  );
}
